import { __assign, __generator, __rest } from "tslib";
import axios from 'axios';
import { put, takeLatest, call, select, all } from 'redux-saga/effects';
import omitBy from 'lodash/omitBy';
import { ALL_FOLDER_ID, SCRAPS_FOLDER_ID, URLS } from '@wix/da-url';
import { request } from '../../xhr';
import { take } from '../../utils/fp';
import { flagEnabled } from '../../redux/flags/selectors';
import { getCurrentUser, getIsMobile, getCsrfToken } from '../../publicSession';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { popModal } from '../../Modals/redux/basicActions';
import { FlowState } from './types';
import { getGalleryId, getSiteId } from './selectors';
import { MODAL_MOUNT, CHANGE_GALLERY_ID, changeGalleryContents, loadGalleries, loadHasWixAccount, changeFlowState, SUBMIT_FORM, loadPreview, setInitialFormState, ACTIVATE_PORTFOLIO, loadEmail, } from './actions';
var fakeGalleries = [];
function getFakeGalleries() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var galleries = require('@wix/da-sample-data')
            .galleries;
        fakeGalleries = take(20, galleries);
    }
    return fakeGalleries;
}
var fakeGalleryContents = [];
function getFakeGalleryContents() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var deviations = require('@wix/da-sample-data')
            .deviationsByType.image;
        fakeGalleryContents = take(20, deviations);
    }
    return fakeGalleryContents;
}
function fetchGalleryContents(username, folderId) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: 'gallection/contents',
                    params: {
                        username: username,
                        folderid: folderId,
                        type: 'gallery',
                        all_folder: folderId === ALL_FOLDER_ID,
                        scraps_folder: folderId === SCRAPS_FOLDER_ID,
                    },
                }, function () { return ({ results: getFakeGalleryContents(), estimatedTotal: 20 }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
function fetchInitData(galleryId) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: 'wix_portfolio/init_modal',
                    params: {
                        folderid: galleryId,
                    },
                }, function () { return ({
                    socialLinks: [
                        {
                            id: 4,
                            value: 'www.facebook.com/incompleteninny',
                        },
                    ],
                    bio: 'I make bad art for my D&D campaigns',
                    tagline: 'This is a tagline',
                    isWixuserExists: false,
                    email: 'luke@skywalker.me',
                    folders: getFakeGalleries(),
                    deviations: {
                        hasMore: true,
                        nextOffset: 10,
                        estimatedTotal: 24,
                        results: getFakeGalleryContents(),
                    },
                }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
function fetchActivatePortfolio() {
    var siteId, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getSiteId)];
            case 1:
                siteId = _a.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'wix_portfolio/activate_portfolio',
                        data: {
                            msid: siteId,
                        },
                    })];
            case 2:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function handleModalMount(action) {
    var user, isMobile, galleryId, initResult, folders, deviations, bio, socialLinks, tagline, hasWixAccount, email;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Make sure we start on the preload state on mount, useful for retrying or remounting
            return [4 /*yield*/, put(changeFlowState(FlowState.PRELOAD))];
            case 1:
                // Make sure we start on the preload state on mount, useful for retrying or remounting
                _a.sent();
                return [4 /*yield*/, select(getCurrentUser)];
            case 2:
                user = _a.sent();
                return [4 /*yield*/, select(getIsMobile)];
            case 3:
                isMobile = _a.sent();
                return [4 /*yield*/, select(getGalleryId)];
            case 4:
                galleryId = _a.sent();
                return [4 /*yield*/, call(fetchInitData, galleryId)];
            case 5:
                initResult = _a.sent();
                if (!(initResult === false || initResult.status === 'error')) return [3 /*break*/, 7];
                return [4 /*yield*/, put(changeFlowState(FlowState.PRELOAD_ERROR))];
            case 6:
                _a.sent();
                return [3 /*break*/, 15];
            case 7:
                folders = initResult.folders, deviations = initResult.deviations, bio = initResult.bio, socialLinks = initResult.socialLinks, tagline = initResult.tagline, hasWixAccount = initResult.isWixuserExists, email = initResult.email;
                return [4 /*yield*/, all([
                        put(loadGalleries(folders)),
                        put(changeGalleryContents(deviations.results.filter(function (deviation) { return getDeviationType(deviation) === DeviationTypes.IMAGE; }), deviations.estimatedTotal)),
                        put(loadEmail(email)),
                        put(setInitialFormState({
                            title: user.username,
                            biography: bio,
                            description: tagline,
                            socialNetworkLinks: socialLinks.reduce(function (obj, networkLink) {
                                var _a;
                                return (__assign(__assign({}, obj), (_a = {}, _a[networkLink.id] = networkLink.value, _a)));
                            }, {}),
                        })),
                        put(loadHasWixAccount(hasWixAccount)),
                    ])];
            case 8:
                _a.sent();
                if (!isMobile) return [3 /*break*/, 10];
                return [4 /*yield*/, put(changeFlowState(FlowState.CALL_TO_ACTION))];
            case 9:
                _a.sent();
                return [3 /*break*/, 15];
            case 10: return [4 /*yield*/, select(flagEnabled, 'portfolio_landing_page')];
            case 11:
                if (!_a.sent()) return [3 /*break*/, 13];
                return [4 /*yield*/, put(changeFlowState(FlowState.LANDING_PAGE))];
            case 12:
                _a.sent();
                return [3 /*break*/, 15];
            case 13: return [4 /*yield*/, put(changeFlowState(FlowState.TERMS))];
            case 14:
                _a.sent();
                _a.label = 15;
            case 15: return [2 /*return*/];
        }
    });
}
export function handleGalleryChange(action) {
    var user, galleryId, _a, results, estimatedTotal;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getCurrentUser)];
            case 1:
                user = _b.sent();
                galleryId = action.payload.galleryId;
                return [4 /*yield*/, call(fetchGalleryContents, user ? user.username : undefined, galleryId)];
            case 2:
                _a = _b.sent(), results = _a.results, estimatedTotal = _a.estimatedTotal;
                return [4 /*yield*/, put(changeGalleryContents(results.filter(function (deviation) {
                        return getDeviationType(deviation) === DeviationTypes.IMAGE;
                    }), estimatedTotal))];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
var DAPI_ROOT = (function () {
    var url = URLS.ROOT + "/dapi/v1";
    if (process.env.NODE_ENV !== 'production') {
        url = url.replace('.com', '.lan');
    }
    return url;
})();
function dapiPost(endpoint, data, options) {
    var onSuccess = options.onSuccess, onError = options.onError, axiosOptions = __rest(options, ["onSuccess", "onError"]);
    return axios
        .request(__assign(__assign({ method: 'post', baseURL: DAPI_ROOT, url: "/" + endpoint }, axiosOptions), { data: data }))
        .then(function (response) {
        onSuccess && onSuccess(response);
        return response.data;
    })
        .catch(function (error) {
        onError && onError(error);
        return false;
    });
}
export function handleSubmitForm(action) {
    var formState, galleryId, csrfToken, filteredData, formData, createResult, portfolio_to_adi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formState = action.payload.formState;
                return [4 /*yield*/, select(getGalleryId)];
            case 1:
                galleryId = _a.sent();
                return [4 /*yield*/, select(getCsrfToken)];
            case 2:
                csrfToken = _a.sent();
                return [4 /*yield*/, put(changeFlowState(FlowState.PREPARING))];
            case 3:
                _a.sent();
                filteredData = omitBy(__assign({ username: formState.title, tagline: formState.description, bio: formState.biography, theme_id: formState.themeId, folder_ids: [galleryId], _csrf: csrfToken }, Object.keys(formState.socialNetworkLinks).reduce(function (obj, key) {
                    obj["social_links[" + key + "]"] = formState.socialNetworkLinks[key];
                    return obj;
                }, {})), function (value) { return !value; });
                formData = new FormData();
                Object.keys(filteredData).forEach(function (key) {
                    formData.append(key, filteredData[key]);
                });
                return [4 /*yield*/, call(dapiPost, 'wixportfolio/create', formData, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        withCredentials: true,
                    })];
            case 4:
                createResult = _a.sent();
                if (!(createResult && createResult.content)) return [3 /*break*/, 8];
                return [4 /*yield*/, put(loadPreview(createResult.content.preview_magic_link, createResult.content.msid))];
            case 5:
                _a.sent();
                return [4 /*yield*/, select(flagEnabled, 'portfolio_to_adi')];
            case 6:
                portfolio_to_adi = _a.sent();
                return [4 /*yield*/, portfolio_to_adi
                        ? call(handleActivatePortfolio)
                        : put(changeFlowState(FlowState.COMPLETE))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, put(changeFlowState(FlowState.PREPARING_ERROR))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}
// Please refer to the readme
function handleActivatePortfolio() {
    var result, portfolio_to_adi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(fetchActivatePortfolio)];
            case 1:
                result = _a.sent();
                if (!(!result || result.status === 'error')) return [3 /*break*/, 3];
                return [4 /*yield*/, put(changeFlowState(FlowState.ACTIVATE_ERROR))];
            case 2:
                _a.sent();
                return [3 /*break*/, 7];
            case 3: return [4 /*yield*/, select(flagEnabled, 'portfolio_to_adi')];
            case 4:
                portfolio_to_adi = _a.sent();
                if (!portfolio_to_adi) return [3 /*break*/, 5];
                window.location.assign('/wixsite/edit');
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put(popModal())];
            case 6:
                _a.sent();
                window.open('/wixsite/edit', '_blank');
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(MODAL_MOUNT, handleModalMount),
                    takeLatest(CHANGE_GALLERY_ID, handleGalleryChange),
                    takeLatest(SUBMIT_FORM, handleSubmitForm),
                    takeLatest(ACTIVATE_PORTFOLIO, handleActivatePortfolio),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map